require('./bootstrap');

import { createApp } from 'vue'
import Tabs from './components/common/Tabs.vue';
import Tab from './components/common/Tab.vue';
import MapView from './components/blas/MapView.vue';
import PreviousYears from './components/blas/PreviousYears.vue';

const app = createApp({
    components: {
        Tabs, Tab, MapView, PreviousYears
    }
}).mount('#app')
